import {useOrgTheme} from "../../context/ThemeContext";

export default function withSQAccess(PageComponent:any) {
  return (props:any) => {
   
    const {isThemeLoaded}=useOrgTheme();

    if(!isThemeLoaded) {
      return <></>
    }
    return <PageComponent {...props} />;
  };
};